import Swiper from "swiper";

const brochuresSlider = document.querySelector(".js-brochures-slider-init");

if (brochuresSlider) {
    new Swiper(".js-brochures-slider-init", {
        slidesPerView: 2,
        spaceBetween: 8,
        pagination: {
            el: ".js-brochures-slider-controls > .swiper-pagination",
            dynamicBullets: true,
            dynamicMainBullets: 3,
            clickable: true,
        },
        navigation: {
            prevEl: ".js-brochures-slider-controls > .swiper-button-prev",
            nextEl: ".js-brochures-slider-controls > .swiper-button-next",
        },
        observer: true,
        watchOverflow: true,
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 28,
            },
        },
    });
}
